const course = {
  state: () => ({
    data: {},
  }),
  mutations: {
    updateCourseData(state, payload) {
      state.data = payload.data;
    },
  },
  actions: {},
};

export default course;
